<div class="container">
	<div class="container__top-part">
		<div class="container__logo">
			<mat-icon svgIcon="logo"></mat-icon>
		</div>
		<div class="container__icons-container">
			<div
				(click)="handleActionClicked(sideBarAction.Search)"
				class="container__icon-wrapper"
				[class.container__icon-wrapper--selected]="selectedSideBarAction() === sideBarAction.Search"
			>
				<mat-icon svgIcon="new_search"></mat-icon>
			</div>
			<div
				(click)="handleActionClicked(sideBarAction.Create)"
				class="container__icon-wrapper"
				[class.container__icon-wrapper--selected]="selectedSideBarAction() === sideBarAction.Create"
			>
				<mat-icon svgIcon="create"></mat-icon>
			</div>
			<div class="container__icon-wrapper" [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
				<!--    TODO: create a component that will be used in this component and in the nav-bar.component-->
				<mat-icon
					#notificationsButton
					[class.menu-open]="menuTrigger.menuOpen"
					svgIcon="new_bell"
					[matBadge]="notificationsCounter?.toString()"
					[matBadgeHidden]="!notificationsCounter"
					matBadgeColor="warn"
					matBadgeSize="small"
					aria-hidden="false"
					[matBadgePosition]="currentLang === languages.EN ? 'below after' : 'below before'"
				></mat-icon>
				<mat-menu #menu="matMenu" backdropClass="notification-drop-down-backdrop" classList="notification-drop-down-container">
					<lawyal-front-end-notification-drop-down
						[notifications]="activeNotifications"
						[isMarkAllAsReadDisabled]="!hasNewNotifications"
						(closeModal)="menuTrigger.closeMenu()"
						(decrementCounter)="decrementCounter()"
						(openModal)="openModalFromSnackBar($event)"
						(runMigration)="onRunMigration($event)"
						(markedAllAsRead)="calcNotifications()"
					></lawyal-front-end-notification-drop-down>
				</mat-menu>
			</div>
		</div>
	</div>
	<mat-icon
		class="container__help-icon"
		matTooltipPosition="after"
		[matTooltip]="'GENERAL.MANUALS' | translate"
		(click)="openZendeskWebWidget()"
		svgIcon="help"
	></mat-icon>
</div>
